import { render, staticRenderFns } from "./apiaries.vue?vue&type=template&id=4281e207&"
import script from "./apiaries.vue?vue&type=script&lang=js&"
export * from "./apiaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports